<template>
    <div class='t_content_view'>
        <div class="t_search_box">
            <div class="t_search_select" >
                <img src="../assets/img/searchgray.png" style="width:14px" alt="">
                <el-input @input="searchinput" size="small" v-model="searchdata.title" placeholder="请输入任务名称"  clearable />
            </div> 
            <el-button @click="resetsearch" color="#F1F3F9" type="primary" style="margin-bottom: 10px;">重置</el-button>
        </div>
        <div style="margin-top: 20px;margin-bottom: 20px;">
            <el-button @click="openmodel('')"  color="#4F46E5" type="primary">新建模板</el-button>
            <el-button  color="#F1F3F9" @click="delall"  type="primary">批量删除</el-button>
        </div>
        <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="tableData.data" style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" />
            <el-table-column prop="corp_name" label="企微主体"  />
            <el-table-column prop="title" label="任务名称"  />
            <el-table-column prop="content" label="内容"  >
                <template #default="scope">
                    {{ scope.row.content }}
                </template>
            </el-table-column>
            <el-table-column prop="address" label="操作">
                <template #default="scope">
                    <el-button style="color:#4F46E5" size="small" type="text" @click="openmodel(scope.row)">编辑</el-button>
                    <el-button style="color:#f56c6c" size="small" type="text" @click="delitem(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <pagechange :total="total" :nowpage="searchdata.page" @page_change="page_change" />
    </div>
    <!-- 新建、编辑 -->
    <el-dialog
        v-model="addmodelshow"
        title="新建/编辑 好友验证语模板"
        width="600px">
        <el-form  label-width="100px">
            <el-form-item  >
                <template #label><span style="color:red">*</span>模板名称:</template>
                <el-input class="t_input_bg" v-model="form.data.title" maxlength="20"  placeholder="请输入模板名称，限20个字"  clearable />
            </el-form-item>
            <el-form-item  >
                <template #label><span style="color:red">*</span>企微主体:</template>
                <el-select class="t_input_bg"    v-model="form.data.corp_id"  clearable placeholder="请选择">
                    <el-option v-for="(item,index) in corpList.data" 
                    :key="index"
                    :label="item.corp_name" :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item  >
                <template #label><span style="color:red">*</span>验证语内容:</template>
                <div style="border: 1px solid #dcdfe6;border-radius: 5px;padding-bottom: 10px;width: 100%;">
                    <el-input @blur="testBlur" class="t_textarea_nobod" v-model="form.data.content" 
                    placeholder="请输入文本内容，限50个字"  type="textarea" rows="7" maxlength="50"  clearable />
                    <el-button @click="addname" style="margin-top: 10px;margin-left: 10px;">插入成员姓名</el-button>
                </div>
                <div class="t_tips_font" style="margin-top: 27px;" >
                    1.建议添加多组验证语，系统将随机发送，降低发送相同内容的风险，提高添加好友通过率
                </div>
                <div style="margin-top: 5px;margin-bottom: 30px;" class="t_tips_font" >
                    2.引用验证语直接覆盖当前已编辑的内容
                </div>
            </el-form-item>
        </el-form>
        <div class="t_cz_box">
            <el-button @click="restmodel"  >取消</el-button>
            <el-button @click="submodel" color="#4F46E5"   type="primary">确定</el-button>
        </div>
    </el-dialog>
</template>

<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
//导入子组件
import pagechange from '../components/pagechange.vue'
import { AddTest,Testlist ,DelTest,DelTestAll,EditTest,CheckTest,newfriendtestlist,newfriendtestadd,newfriendtestdel,newgetcomp2} from '@/assets/js/common.js'
//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()
//动态获取接口地址
const _url2 = inject('_url2')
onMounted(() => {
    console.log('onMounted')
    //人员列表
    getlist()
    //获取企微主体下拉
    getcorplist()
})
//企微主体下拉
const corpList = reactive({
    data:[]
})
//获取企微主体下拉
const getcorplist = ()=>{
    newgetcomp2().then((response)=>{
        if (response.data.msg.code == 0) {
            corpList.data = response.data.data
            console.log('企微主体下拉')
            console.log(corpList.data)
        }
    })
}
//搜索内容
const searchdata  = reactive({
    title:'',
    page:1,
    page_size:20,
})
//监听搜索文本框内容变化
const searchinput = (e)=>{
    console.log(e)
    searchdata.title = e
    searchdata.page=1
    getlist()
}
//重置
const resetsearch = ()=>{
    searchdata.title=''
    searchdata.page=1
    getlist()
}

//列表内容
const tableData = reactive({
    data:[]
})
//总数
const total = ref(0)
//监听分页
const page_change = (val)=>{
    searchdata.page = val
    //人员列表
    getlist()
}

//获取列表
const getlist = ()=>{
    console.log('获取列表')
    newfriendtestlist(searchdata).then((response)=>{
        console.log('列表')
        console.log(response)
        tableData.data = response.data.data.data
        total.value = response.data.data.total
    })
}
//多选
const delarr = reactive({
    data:[]
})
const handleSelectionChange = (val)=>{
    delarr.data = val
}
//删除
const delitem = (id)=>{
    ElMessageBox.confirm(
        '是否确认删除？',
        '提示',
        {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        }
    )
    .then(() => {
        newfriendtestdel({id:id.toString()}).then((response)=>{
            if(response.data.msg.code==0){
                searchdata.page=1
                getlist()
                ElMessage({
                    type: 'success',
                    message: '操作成功',
                })
            }
        })
        
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '已取消',
      })
    })
}
//批量删除
const delall = ()=>{
    
    if(delarr.data.length==0){
        ElMessage.error('请先选择')
        return
    }
    var ids = []
    for(var x = 0;x<delarr.data.length;x++){
        ids.push(delarr.data[x].id)
    }
   console.log(ids)
    ElMessageBox.confirm(
        '是否确认删除？',
        '提示',
        {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        }
    )
    .then(() => {
        newfriendtestdel({id:ids.join(',')}).then((response)=>{
            if(response.data.msg.code==0){
                searchdata.page=1
                getlist()
                ElMessage({
                    type: 'success',
                    message: '操作成功',
                })
            }
        })
        
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '已取消',
      })
    })
}
//新建、编辑 弹窗
const addmodelshow = ref(false)
//打开弹窗
const openmodel = (row)=>{
    addmodelshow.value = true

    //清空数据
    
    form.data.title = ''
    form.data.content = ''
    //判断新增还是编辑
    if(row){
        //编辑
        console.log(row.id)
        // CheckTest(_url2,{id:row.id}).then((response)=>{
        //     console.log(response.data.result.id)
        //     form.data.id = response.data.result.id
        //     form.data.name = response.data.result.name
        //     form.data.textList = response.data.result.textList
        // })

        form.data.id = row.id
        form.data.title = row.title
        form.data.content = row.content
        form.data.corp_id = row.corp_id
       
        console.log('编辑')
    }else{
        //新增
        form.data.id = ''
        console.log('新增')
    }
}
//弹窗内容
const form = reactive({
    data:{
        id:'',
        corp_id:'',
        
        title:'',
        content:''
    }
})
//储存焦点位置
const Blurindex = ref(0)
//获取焦点位置
const testBlur = (e)=>{
    console.log('获取焦点')
    console.log(e.srcElement.selectionStart)
    Blurindex.value = e.srcElement.selectionStart
}
//插入成员名
const addname = ()=>{

    var yuantest = form.data.content
    form.data.content = yuantest.slice(0,Blurindex.value)+'${name}'+yuantest.slice(Blurindex.value)

    
}
//取消
const restmodel = ()=>{
    addmodelshow.value = false
}
//提交
const submodel = ()=>{
    //验证必填
    if(form.data.title == '' ){
        ElMessage.error('请输入标题')
        return
    }else if(form.data.content==''){
        ElMessage.error('请输入内容')
        return
    }else if(form.data.corp_id == ''){
        ElMessage.error('请选择企微主体')
        return
    }
    console.log(form.data)
    
    newfriendtestadd(form.data).then((response)=>{
                console.log(response)
                if(response.data.msg.code==0){
                    addmodelshow.value = false
                    //人员列表
                    getlist()
                    ElMessage({
                        type: 'success',
                        message: '操作成功',
                    })
                }
                
            })
        // EditTest
        // if(form.data.id){
        //     //编辑
        //     console.log('编辑')
        //     EditTest(_url2,form.data).then((response)=>{
        //         console.log(response)
        //         if(response.data.msg.code==0){
        //             addmodelshow.value = false
        //             //人员列表
        //             getlist()
        //             ElMessage({
        //                 type: 'success',
        //                 message: '操作成功',
        //             })
        //         }
                
        //     })
        // }else{
        //     //新增
        //     console.log('新增')
        //     AddTest(_url2,form.data).then((response)=>{
        //         console.log(response)
        //         if(response.data.msg.code==0){
        //             addmodelshow.value = false
        //             //人员列表
        //             getlist()
        //             ElMessage({
        //                 type: 'success',
        //                 message: '操作成功',
        //             })
        //         }
                
        //     })
        // }
        
      
}
</script>

<style scoped>
:deep( .t_search_box .el-input__wrapper) {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep( .t_input_bg .el-input__wrapper ){
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep( .t_input_bg .el-select__wrapper ){
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep( .t_textarea_nobod .el-textarea__inner ){
    
    box-shadow: 0 0 0 0 ;
    resize: none;
    border-bottom: 1px solid #dcdfe6;
}
.t_tips_font{
    color: #777777;
    font-size: 13px;
    line-height: 18px;
}

</style>